import LayersClearIcon from "@mui/icons-material/LayersClear";
import ShareIcon from "@mui/icons-material/Share";
import { Box, Button } from "@mui/material";
import * as React from "react";

// TODO(Pratik) Move this component to shared location
import { ViewFileControls } from "@/Files/File/FileHeader/controls/ViewFileControls";
import { useAuth } from "@/providers";
import { useDomainServices } from "@/providers/DomainServices";
import { SharedWorkspaceLinkModal, ViewAsOrgButton } from "@/shared/components";
import { WorkspaceRecord } from "@/shared/domain/workspaces/WorkspaceRecord";
import { usePopupState } from "@/shared/hooks";
import { ErrorMonitoringService } from "@/shared/services";
import {
  actions,
  useFiles,
  useVizDispatch,
  useVizState,
} from "@/shared/state/visualization";

import { AddPanel } from "../controls/AddPanel";
import { SelectActiveLayout } from "../controls/SelectActiveLayout";
import { SelectLayout } from "../controls/SelectLayout/SelectLayout";
import { ToggleSidebar } from "../controls/ToggleSidebar";
import {
  useActiveLayout,
  useEphemeralWorkspaceState,
} from "../WorkspaceCtx/hooks";

import { DatasourceInfo } from "./DatasourceInfo";
import styles from "./Header.module.css";

export function Header() {
  const dispatch = useVizDispatch();
  const state = useVizState();

  const { workspaceService } = useDomainServices();

  const { currentOrganization } = useAuth();

  const files = useFiles();
  const { files: fileRecords } = useEphemeralWorkspaceState();

  const layoutMenuPopup = usePopupState();
  const workspacePopup = usePopupState();
  const [record, setRecord] = React.useState<WorkspaceRecord | null>(null);
  const [createWorkspaceError, setCreateWorkspaceError] =
    React.useState<Error | null>(null);

  const [activeLayout] = useActiveLayout();

  return (
    <>
      <div className={styles.twoColumnLayout}>
        <div className={styles.navigation}>
          <ToggleSidebar />
          <DatasourceInfo className={styles.shrinkable} />
        </div>
        <Box
          className={styles.actions}
          sx={{
            display: {
              xs: "none",
              md: "flex",
            },
          }}
        >
          <ViewAsOrgButton
            orgId={fileRecords[0]?.org_id}
            size="small"
            variant="icon"
          />
          <SelectActiveLayout activeLayout={activeLayout} />
          <div className={styles.buttonGroup}>
            <AddPanel />
            <Button
              color="error"
              className={styles.actionButton}
              disableElevation
              onClick={() => dispatch(actions.removeAllPanels())}
              size="small"
              startIcon={<LayersClearIcon />}
              variant="outlined"
            >
              Clear
            </Button>
            <Button
              color="primary"
              variant="outlined"
              disableElevation
              startIcon={<ShareIcon />}
              className={styles.actionButton}
              size="small"
              onClick={() => {
                const orgId = currentOrganization?.org_id || "";

                workspaceService
                  .createWorkspace(state, orgId)
                  .then((record: WorkspaceRecord) => {
                    setRecord(record);
                    setCreateWorkspaceError(null);
                  })
                  .catch((e: Error) => {
                    ErrorMonitoringService.captureError(e);
                    setCreateWorkspaceError(e);
                    setRecord(null);
                  })
                  .finally(workspacePopup.open);
              }}
            >
              Share
            </Button>
            {files.length === 1 && (
              <ViewFileControls fileRecord={fileRecords[0]} />
            )}
          </div>
        </Box>
      </div>
      <SharedWorkspaceLinkModal
        open={workspacePopup.isOpen}
        record={record}
        handleClose={() => {
          setRecord(null);
          workspacePopup.close();
        }}
        error={createWorkspaceError}
      />
      <SelectLayout
        anchorEl={layoutMenuPopup.anchor}
        isOpen={layoutMenuPopup.isOpen}
        onClose={layoutMenuPopup.close}
      />
    </>
  );
}
